export default __webpack_public_path__ + "static/ProdigySans-SemiBold-6be9bc32d9026eb6e8d99c148676f375.woff2";